<template>
    <div class="calendar-row calendar-row-header">
        <calendar-header-cell :title="'Semaine ' + weekNumber" danger actions>
            <template v-slot:extend-actions>
                <div class="flex items-center justify-end">
                    <div class="mr-1">
                        <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-success" @click="$emit('toggle-extend-technicians', { extended: true, weekNumber })">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
                        </md-button>
                    </div>
                    <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-danger" @click="$emit('toggle-extend-technicians', { extended: false, weekNumber })">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'minus']" />
                    </md-button>
                </div>
            </template>
        </calendar-header-cell>
        <calendar-header-cell v-for="(day, index) in days" :key="index" :day="day"></calendar-header-cell>
    </div>
</template>

<script>
import CalendarHeaderCell from "@/pages/Planning/Calendar/components/calendar/CalendarHeaderCell";

export default {
    name: "CalendarRowHeader",
    components: {
        CalendarHeaderCell
    },
    props: {
        weekNumber: Number,
        days: Array
    },
}
</script>

<style scoped>

</style>
